export default __webpack_public_path__ + "static/caption-03-cht-03fbe63265d918b132777c84070a6aab.webp";